import { createReducer } from '@reduxjs/toolkit';
import {
    setCollectionsRecords,
    setCollectionsLoading,
    removeCollectionRecord,
    setCollectionIdentifiers,
    addNewCollectionIdentifiers,
} from './actions';
import type { CollectionsDataModel } from './types';

interface CollectionsState {
    records: Record<string, CollectionsDataModel>;
    identifiers: Array<CollectionsDataModel['id']>;
    isLoading: boolean;
}

export const collectionsReducer = createReducer<CollectionsState>(
    {
        records: {},
        identifiers: [],
        isLoading: false,
    },
    (builder) => {
        builder
            .addCase(setCollectionsRecords, (draft, action) => {
                action.payload.forEach((collection) => {
                    draft.records[collection.id] = collection;
                });
            })
            .addCase(setCollectionIdentifiers, (draft, action) => {
                draft.identifiers = action.payload;
            })
            .addCase(addNewCollectionIdentifiers, (draft, action) => {
                // первый элемент всегда дефолтная коллекция
                draft.identifiers = [
                    draft.identifiers[0],
                    ...action.payload,
                    ...draft.identifiers.slice(1),
                ];
            })
            .addCase(setCollectionsLoading, (draft, action) => {
                const { isLoading } = action.payload;

                draft.isLoading = isLoading;
            })
            .addCase(removeCollectionRecord, (draft, action) => {
                delete draft.records[action.payload];
                draft.identifiers = draft.identifiers.filter((id) => id !== action.payload);
            });
    },
);
